import { Box, Typography } from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Circle from "../Circle/Circle.jsx";
import useStyles from "./style.js";
import { useMediaQuery } from "@material-ui/core";
const Instructions = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  const classes = useStyles();

  const circleSettings = "leftCircle";

  return (
    <Box
      component="div"
      className={!mobile ? classes.instructions : classes.instructionsMob}
    >
      <Circle circleClass={circleSettings} />
      <Box
        component="div"
        className={!mobile ? classes.content : classes.contentMob}
      >
        <Typography
          variant="h2"
          className={!mobile ? classes.title : classes.titleMob}
        >
          Cómo funciona
        </Typography>
        <Box
          component="div"
          className={!mobile ? classes.work : classes.workMob}
        >
          <Box component="div" className={classes.text}>
            <Typography
              className={!mobile ? classes.subtitle : classes.subtitleMob}
              variant="h3"
              color="primary"
            >
              Busca la dirección de tu destino
            </Typography>
            <Typography
              className={!mobile ? classes.paragraph : classes.paragraphMob}
              p="true"
            >
              Ingresa a donde deseas ir y pulsa «Solicitar Servicio». Si no
              conoces la ruta, la aplicación te dará un estimado de precio.
            </Typography>
          </Box>

          {!mobile ? (
            <KeyboardArrowRightIcon className={classes.icon} />
          ) : (
            <KeyboardArrowDownIcon className={classes.icon} />
          )}

          <Box component="div" className={classes.text}>
            <Typography
              className={!mobile ? classes.subtitle : classes.subtitleMob}
              variant="h3"
              color="primary"
            >
              Un conductor aceptará tu solicitud
            </Typography>
            <Typography
              className={!mobile ? classes.paragraph : classes.paragraphMob}
              p="true"
            >
              Al aceptar, te daremos a conocer la información de tu conductor y
              llegará por ti.
            </Typography>
          </Box>
          {!mobile ? (
            <KeyboardArrowRightIcon className={classes.icon} />
          ) : (
            <KeyboardArrowDownIcon className={classes.icon} />
          )}
          <Box component="div" className={classes.text}>
            <Typography
              className={!mobile ? classes.subtitle : classes.subtitleMob}
              variant="h3"
              color="primary"
            >
              Disfruta tu viaje
            </Typography>
            <Typography
              className={!mobile ? classes.paragraph : classes.paragraphMob}
              p="true"
            >
              Comparte tu viaje a tus conocidos y ve la ruta en tiempo real.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Instructions;
